import { get } from 'lodash';

import * as PaymentApi from '@/api/payment';
import actionTypes from './actionType';

const toggleCreditDrawerVisible = (visible) => {
  return {
    type: actionTypes.TOGGLE_CREDIT_DRAWER_VISIBLE,
    payload: {
      drawerVisible: visible,
    },
  };
};

const initAllOta = () => {
  return async (dispatch) => {
    try {
      const res = await PaymentApi.fetchAllOta();
      const obj = get(res, 'data', []);
      const allOta = Object.keys(obj).map((item) => {
        return {
          value: item,
          label: obj[item],
        };
      });
      dispatch({
        type: actionTypes.INIT_ALL_OTA,
        payload: {
          allOta,
        },
      });
    } catch (e) {
      dispatch({
        type: actionTypes.INIT_ALL_OTA,
        payload: {
          allOta: [],
        },
      });
    }
  };
};

export { toggleCreditDrawerVisible, initAllOta };
